<template>
  <div class="info-modal__content__title">
    <h4>{{ $t('modal_content.employer_subsidy.title') }}</h4>
  </div>
  <div class="info-modal__content__text">
    {{ $t('modal_content.employer_subsidy.text') }}
  </div>
</template>

<script setup lang="ts"></script>
